module.exports = __webpack_public_path__ + "03929559703716637db4996bb9b9fd98.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/throne.png
// module id = 2020
// module chunks = 0